document.addEventListener('DOMContentLoaded', function () {
    const root = document.getElementById('auth-reset-root');
    if (!root) return;

    const ajaxUrl = root.dataset.ajaxUrl;
    const nonce = root.dataset.nonce;

    console.log('ajaxUrl =', ajaxUrl);
    console.log('nonce =', nonce);

    let currentUserId = null;
    let userPhoneCode = null;
    let timerId = null;
    let timerEnd = null;

    const stepPhone = root.querySelector('.auth-reset__step--phone');
    const stepCode = root.querySelector('.auth-reset__step--code');
    const stepPassword = root.querySelector('.auth-reset__step--password');
    const stepSuccess = root.querySelector('.auth-reset__step--success');

    const phoneForm = document.getElementById('auth-reset-phone-form');
    const codeForm = document.getElementById('auth-reset-code-form');
    const passForm = document.getElementById('auth-reset-password-form');

    const phoneInput = document.getElementById('reset-phone');
    const phoneCode = document.getElementById('reset-phone-code');
    const phoneError = stepPhone.querySelector('[data-error="phone"]');

    const phoneLabel = document.getElementById('auth-reset-phone-label');
    const codeInputs = Array.from(
        document.querySelectorAll('.auth-reset-code__input')
    );
    const codeError = document.getElementById('auth-reset-code-error');
    const limitError = document.getElementById('auth-reset-limit-error');
    const resendBtn = document.getElementById('auth-reset-resend-btn');
    const timerEl = document.getElementById('auth-reset-timer');

    const pass1 = document.getElementById('reset-pass-1');
    const pass2 = document.getElementById('reset-pass-2');
    const passErr1 = stepPassword.querySelector('[data-error="password_1"]');
    const passErr2 = stepPassword.querySelector('[data-error="password_2"]');

    function showStep(step) {
        [stepPhone, stepCode, stepPassword, stepSuccess].forEach(el => {
            if (!el) return;
            el.classList.toggle('is-active', el === step);
        });
    }

    function startTimer(seconds) {
        if (timerId) clearInterval(timerId);
        timerEnd = Date.now() + seconds * 1000;

        resendBtn.style.display = 'none';
        timerEl.style.display = 'inline';

        function tick() {
            const leftMs = timerEnd - Date.now();
            if (leftMs <= 0) {
                clearInterval(timerId);
                timerId = null;
                timerEl.style.display = 'none';
                resendBtn.style.display = 'inline-block';
                return;
            }
            const leftSec = Math.floor(leftMs / 1000);
            const m = String(Math.floor(leftSec / 60)).padStart(2, '0');
            const s = String(leftSec % 60).padStart(2, '0');
            timerEl.textContent = `Надіслати повторно через ${m}:${s}`;
        }

        tick();
        timerId = setInterval(tick, 1000);
    }

    function post(urlAction, data) {
        const fd = new FormData();
        fd.append('action', urlAction);   // <-- використовуємо параметр
        fd.append('nonce', nonce);
        Object.keys(data).forEach(k => fd.append(k, data[k]));

        console.log(ajaxUrl);
        console.log(fd);
        console.log(data);
        console.log(nonce);
        console.log(urlAction);

        return fetch(ajaxUrl, { method: 'POST', body: fd })
            .then(async r => {
                const text = await r.text();
                console.log('AJAX status', r.status);
                console.log('AJAX raw response:', text);
                return JSON.parse(text);
            });
    }

    // STEP 1: send code
    phoneForm.addEventListener('submit', function (e) {
        e.preventDefault();
        phoneError.textContent = '';
        const val = phoneInput.value.replace(/\D/g, '');
        if (!val || val.length !== 9) {
            phoneError.textContent = 'Вкажіть коректний номер телефону.';
            return;
        }

        post('kitan_reset_send_code', {
            phone: phoneInput.value,
            phone_code: phoneCode.value
        }).then(res => {
            if (!res || !res.success) {
                phoneError.textContent = res?.data?.message || 'Сталася помилка.';
                return;
            }

            // тут краще замаскувати телефон на PHP, але для простоти показуємо як є
            phoneLabel.textContent = res.data.phone_mask;
            currentUserId = res.data.user_id || null; // якщо додаси в PHP
            showStep(stepCode);
            codeInputs.forEach(i => i.value = '');
            codeInputs[0].focus();
            codeError.textContent = '';
            limitError.textContent = '';
            startTimer(300);
        }).catch(() => {
            phoneError.textContent = 'Сталася помилка. Спробуйте ще раз.';
        });
    });

    // code inputs auto-move + auto-submit
    codeInputs.forEach((input, idx) => {
        input.addEventListener('input', function () {
            this.value = this.value.replace(/\D/g, '').slice(0, 1);

            if (this.value && idx < codeInputs.length - 1) {
                codeInputs[idx + 1].focus();
            }

            if (this.value && idx === codeInputs.length - 1) {
                const code = codeInputs.map(i => i.value).join('');
                if (code.length === codeInputs.length) {
                    codeForm.dispatchEvent(new Event('submit', { cancelable: true }));
                }
            }
        });

        input.addEventListener('keydown', function (e) {
            if (e.key === 'Backspace' && !this.value && idx > 0) {
                codeInputs[idx - 1].focus();
            }
        });
    });

    // STEP 2: verify code
    codeForm.addEventListener('submit', function (e) {
        e.preventDefault();
        const code = codeInputs.map(i => i.value).join('');
        codeError.textContent = '';
        limitError.textContent = '';

        if (code.length !== 5) {
            codeError.textContent = 'Введіть повний код.';
            return;
        }

        post('kitan_reset_verify_code', {
            code: code,
            user_id: currentUserId || ''
        }).then(res => {
            if (!res || !res.success) {
                const data = res?.data || {};
                if (data.limit) {
                    limitError.textContent = 'Ліміт у 3 спроби вичерпано. Ви можете замовити новий код.';
                } else if (data.expired) {
                    codeError.textContent = 'Код прострочено. Замовте новий.';
                } else {
                    codeError.textContent = data.message || 'Невірний код. Спробуйте ще раз.';
                }
                codeInputs.forEach(i => i.classList.add('is-error'));
                return;
            }
            codeInputs.forEach(i => i.classList.remove('is-error'));
            currentUserId = res.data.user_id;
            userPhoneCode = code;
            showStep(stepPassword);
        }).catch(() => {
            codeError.textContent = 'Сталася помилка. Спробуйте ще раз.';
        });
    });

    // resend
    resendBtn.addEventListener('click', function () {
        if (!currentUserId) return;
        post('kitan_reset_resend_code', { user_id: currentUserId }).then(res => {
            if (!res || !res.success) {
                codeError.textContent = res?.data?.message || 'Сталася помилка.';
                return;
            }
            codeInputs.forEach(i => i.value = '');
            codeInputs[0].focus();
            codeError.textContent = '';
            limitError.textContent = '';
            startTimer(300);
        }).catch(() => {
            codeError.textContent = 'Сталася помилка. Спробуйте ще раз.';
        });
    });

    // password meter (спрощений – як на реєстрації)
    const pwdMeter = stepPassword.querySelector('.auth-password-meter');
    const pwdLabel = pwdMeter ? pwdMeter.querySelector('.auth-password-meter__label') : null;
    const pwdSegs = pwdMeter ? pwdMeter.querySelectorAll('.segment') : null;
    const pwdRules = stepPassword.querySelectorAll('.auth-password-rule');

    function updatePwdStrength() {
        if (!pass1 || !pwdMeter || !pwdLabel || !pwdSegs) return;
        const val = pass1.value;
        const hasLen = val.length >= 8;
        const hasDig = /\d/.test(val);
        const hasUp = /[A-ZА-ЯЇІЄЎҐ]/u.test(val);

        let score = 0;
        pwdRules.forEach(el => {
            const rule = el.dataset.rule;
            let ok = false;
            if (rule === 'length') ok = hasLen;
            if (rule === 'digits') ok = hasDig;
            if (rule === 'letters') ok = hasUp;
            if (ok) {
                el.classList.add('is-valid');
                score++;
            } else {
                el.classList.remove('is-valid');
            }
        });

        pwdSegs.forEach(s => s.classList.remove('is-filled'));
        pwdLabel.classList.remove('is-filled');

        if (!val.length) {
            pwdLabel.textContent = 'Введіть пароль';
            return;
        }

        const fill = Math.min(score + 1, pwdSegs.length);
        for (let i = 0; i < fill; i++) pwdSegs[i].classList.add('is-filled');

        if (score <= 1) pwdLabel.textContent = 'Слабкий';
        else if (score === 2) pwdLabel.textContent = 'Нормальний';
        else pwdLabel.textContent = 'Надійний';

        pwdLabel.classList.add('is-filled');
    }

    if (pass1) pass1.addEventListener('input', updatePwdStrength);

    // STEP 3: set password
    passForm.addEventListener('submit', function (e) {
        e.preventDefault();
        passErr1.textContent = '';
        passErr2.textContent = '';

        const v1 = pass1.value;
        const v2 = pass2.value;
        const hasLen = v1.length >= 8;
        const hasDig = /\d/.test(v1);
        const hasUp = /[A-ZА-ЯЇІЄЎҐ]/u.test(v1);

        if (!v1) {
            passErr1.textContent = 'Вкажіть пароль.';
            return;
        }
        if (!(hasLen && hasDig && hasUp)) {
            passErr1.textContent = 'Пароль має містити мінімум 8 символів, цифри та великі літери.';
            return;
        }
        if (v1 !== v2) {
            passErr2.textContent = 'Паролі не збігаються.';
            return;
        }

        post('kitan_reset_set_password', {
            user_id: currentUserId || '',
            code: userPhoneCode,
            password_1: v1,
            password_2: v2
        }).then(res => {
            if (!res || !res.success) {
                passErr2.textContent = res?.data?.message || 'Сталася помилка. Спробуйте ще раз.';
                return;
            }
            showStep(stepSuccess);
        }).catch(() => {
            passErr2.textContent = 'Сталася помилка. Спробуйте ще раз.';
        });
    });
});
